// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Services
import { geMarginStatus } from "src/Requests/imePortfolio";
// Types
import {
  IUserPositionSummarySearchParams,
  IUserPositionSummaryTableReport,
} from "src/Interfaces/imePortfolio";
import PortfoTableSection from "./PortfoTableSection";

interface IProps {
  searchParams: IUserPositionSummarySearchParams;
  totalRefreshFlag: boolean;
}

const MarginStatus = ({ searchParams, totalRefreshFlag }: IProps) => {
  return (
    <PortfoTableSection title="وضعیت نقدینگی و مارجین">
      <TableTemplate<
        IUserPositionSummarySearchParams,
        IUserPositionSummaryTableReport
      >
        getDataTable={geMarginStatus}
        tableWrapperClassname="w-full justify-start"
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            sortingType={sortingType}
            setSortingType={setSortingType}
            tableBoxClassName="!mx-0"
            tableHeaderClassName="!bg-sky-50 hover:!bg-sky-100"
            onAction={onAction}
            refreshFlag={totalRefreshFlag}
          />
        )}
        withSort
        searchParameters={searchParams}
      />
    </PortfoTableSection>
  );
};

export default MarginStatus;
